/* eslint-disable canonical/filename-match-exported -- FIXME: Fix this ESLint violation! */
import type { ElementType } from 'react'
import { useState, useEffect } from 'react'

import { toHHMMSS } from '@src/lib/date'
import type { TypographyProps } from '@ui/Typography'
import Typography from '@ui/Typography'

type TimerProps = Omit<TypographyProps<ElementType>, 'ref'> & {
  startTimestamp: number
}

const Timer = ({ startTimestamp, ...props }: TimerProps) => {
  const [seconds, setSeconds] = useState(0)

  useEffect(() => {
    const id = setInterval(() => {
      const seconds = Math.floor((Date.now() - startTimestamp) / 1000)
      setSeconds(Math.max(0, seconds))
    }, 1000)
    return () => clearInterval(id)
  }, [startTimestamp])

  return <Typography {...props}>{startTimestamp ? toHHMMSS(seconds) : '0:00'}</Typography>
}

export default Timer
